import axios from "axios";
import { cacheAction } from 'vuex-cache';


export default {
  namespaced: true,
  state: {
    features: {}
  },
  getters: {
    getFeatureStatusByName: (state) => (queryFeature) => {
      let feature = state.features.find(f => f.feature === queryFeature)
      return Boolean(feature.active_at);
    }
  },
  mutations: {
    setFeatures (state, features) {
      state.features = features;
    },
  },
  actions: {
    async loadFeatures ({commit}) { // TODO Cache with vuex-cache
      return axios.get('/features').then(res => {
          commit('setFeatures', res.data.features);
        }
      );
    },
  }
};
